var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('kt-panel',[(_vm.status !== 'loading')?_c('kt-panel-body',[(_vm.form_data.status == _vm.statuses.REJECTED)?_c('dedicated-form-editable',{attrs:{"form_data":_vm.form_data,"submit":_vm.submitFullForm}}):_c('dedicated-form',{attrs:{"form_data":_vm.form_data,"submit":_vm.submit}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }